import { get } from 'svelte/store';
import { currentLang } from './lang';
import { dictionary } from './dictionary';
export function t(key, params) {
    var _a;
    const lang = get(currentLang);
    let text = (_a = dictionary[lang][key]) !== null && _a !== void 0 ? _a : key;
    if (params) {
        for (const [k, v] of Object.entries(params)) {
            text = text.replaceAll(`{${k}}`, String(v));
        }
    }
    return text;
}
